import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit"
import cateringReducer from '../features/catering/cateringSlice'

export const store = configureStore({
  reducer: {
    catering: cateringReducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
